import { twMerge } from 'tailwind-merge'

export function DuoCheckIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={twMerge('text-duo-green h-6 w-6', className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.5 12.5l5 5 10-11"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DuoCrossIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={twMerge('text-duo-line-dark h-6 w-6', className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function DuoChevronIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={twMerge('h-5 w-5', className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 9l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
